import React from 'react';
import { ShieldIcon, ClockIcon, BellIcon } from '../Icons';
import './EstadoCaso.css';

// La consulta de estado dejó de vivir en el sitio: ahora la atiende el portal
// nuevo. Esta sección queda solo como puerta de entrada hacia allá.
const PORTAL_ESTADO_URL = 'https://tabularis.cl/estado';

const EstadoCaso: React.FC = () => (
  <section id="estado" style={{ background: 'var(--dark-3)' }}>
    <div className="estado-container">
      <div>
        <div className="section-label">Portal de Clientes</div>
        <h2 className="section-title">Estado de<br /><em>su caso</em></h2>
        <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)', lineHeight: 1.9, marginTop: '0.5rem', marginBottom: '2rem' }}>
          Consulte el avance de su causa, próximas audiencias y documentos relevantes
          en nuestro portal de clientes, con el código único que le proporcionamos al
          inicio de su proceso.
        </p>

        <a
          href={PORTAL_ESTADO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="estado-portal-btn"
        >
          Consultar mi caso
        </a>

        <p style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: '0.9rem' }}>
          ¿No tiene su código? Contáctenos vía WhatsApp o llame a nuestras oficinas.
        </p>
      </div>

      <div className="estado-info">
        <div className="estado-feature">
          <div className="estado-feature-icon"><ShieldIcon /></div>
          <div>
            <div className="estado-feature-title">Acceso seguro y privado</div>
            <div className="estado-feature-desc">Su información está protegida. Solo usted, con su código único, puede ver el avance de su causa.</div>
          </div>
        </div>
        <div className="estado-feature">
          <div className="estado-feature-icon"><ClockIcon /></div>
          <div>
            <div className="estado-feature-title">Actualización en tiempo real</div>
            <div className="estado-feature-desc">Cada vez que exista un avance en su proceso, el estado se actualiza automáticamente.</div>
          </div>
        </div>
        <div className="estado-feature">
          <div className="estado-feature-icon"><BellIcon /></div>
          <div>
            <div className="estado-feature-title">Notificaciones</div>
            <div className="estado-feature-desc">Reciba avisos por WhatsApp o correo cuando haya novedades en su causa.</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EstadoCaso;
